<i18n>
{
    "ru": {
        "sort": "Сортировка",
        "filter": "Фильтр",
        "years_one": "года",
        "years_decade": "годов",
        "title": "Ароматы",
        "description": "Хронология всех парфюмерных запусков от первого в истории аромата до новейших разработок нишевых марок",
        "placeholder": "Введите название аромата...",
        "sort_desc": "По убыванию",
        "sort_asc": "По возрастанию",
        "perfumes_one": "аромат",
        "perfumes_few": "аромата",
        "perfumes_many": "ароматов",
        "date": "По дате выпуска",
        "rating": "По рейтингу",
        "popular": "По популярности",
        "alphabet": "По алфавиту",
        "best_articles": "Лучшие статьи",
        "chained_pages": "Интересные подборки",
        "by_filter": "(по фильтру)"
    }
}
</i18n>

<template>
    <div class="year-page">

        <block-price-panel />

        <transition name="fade">
            <ModalFilter
                v-show="filterIsShowed"
                :disable-modal-parent-scroll="filterIsShowed"
                @close-sidebar="filterIsShowed = false"
                :isOpened="filterIsShowed"
                :filtersCount="filtersCount"
                :params="filterParams">
                <template #filter-body>
                    <PerfumesFilter 
                        ref="filter"
                        :fields="filterFields" 
                        :settedValues="filterParams" 
                        :additionalValues="{q: searchQuery}"
                        :isModal="true"
                        @change="filtersCount = $event.count"
                        @submit="onFilterSubmit"
                        @reset="onFilterReset"
                        class="cat-filter_modal" />
                </template>
            </ModalFilter>
        </transition>
        <div class="year-page__block">
            <PageBlock :content-visible="isDeviceDesktop">
                <Breadcrumb
                    show-prev-button
                    prev-path-name="Years"
                    :items="breadcrumbs"/>

                <SectionCard :loaded="loaded">
                    <template #main>
                        <div class="year-page__content">
                            <PageBlock
                                :title="getYearTitle"
                                :caption="yearPerfumesCaption"
                                :caption-count="perfumesCount"
                                :description="get(year, 'perfumes.description', null)"
                                :small-header="!isDeviceDesktop"
                                class="year-page__title-name"
                                :heading-tag="'h1'" />
                        </div>
                    </template>
                </SectionCard>
            </PageBlock>

            <PageBlock :content-visible="isDeviceDesktop">
                <AromaBox :aromabox="yearAromabox" />
            </PageBlock>

            <PageBlock :content-visible="isDeviceDesktop">
                <CatalogList
                    :filters-count="filtersCount"
                    :grid="isDeviceDesktop"
                    :sortInSearchField="isDeviceDesktop"
                    :filterInSearchField="isDeviceDesktop"
                    :grid-columns="5"
                    id="catalog"
                    :placeholder="$t('placeholder')"
                    :search-loading="queryPending"
                    @search="searchQuery = $event"
                    :query="searchQuery"
                    @change-sort-type="onChangeSortType"
                    @change-sort-order="onChangeSortOrder"
                    @show-filter="filterIsShowed = true"
                    @reset-all="resetAll"
                    :with-pagination="false"
                    :single-button-pagination="parseInt(catalogLastPage) > parseInt(catalogPage)"
                    with-filter
                    :sort-options="sortOptions"
                    v-model="catalogPage"
                    :page-count="catalogLastPage"
                    :sort-order="sortOrder"
                    :sort-type="sortType"
                    class="year-page__catalog"
                    :items="catalogItems">

                    <template #item="{ item }" >

                        <BlockOffer
                            :brand-name="get(item, 'brand.name')"
                            :name="get(item, 'name')"
                            :url="get(item, 'htmlUrl')"
                            :picture="get(item, 'picture.url')"
                            :produced-from="get(item, 'produced.from')"
                            :gender-code="get(item, 'gender.code')"
                            :rating="get(item, 'ratings.value')"
                            with-rating
                            :direction-column="isDeviceDesktop"
                            :comments-count="get(item, 'comments.total')"
                            :caption="get(item, 'concentration.name', 0)"/>

                    </template>
                </CatalogList>

            </PageBlock>
            <PageBlock v-if="relatedArticles && relatedArticles.length && !isDeviceDesktop" :title="$t('best_articles')">
                <div class="perfume__page-block">
                    <ArticleRowItem
                        :key="index + article.code"
                        v-for="(article, index) in relatedArticles"
                        :data="article"/>
                </div>
            </PageBlock>
            <PageBlock v-if="relatedPages && relatedPages.length && !isDeviceDesktop" :title="$t('chained_pages')">
                <div class="perfume__page-block">
                    <LinkedPagesList :items="relatedPages"/>
                </div>
            </PageBlock>
        </div>

        <!-- <modal
            name="catalog-filter"
            inline
            v-bind="filterOptions">

            <CatalogFilter
                v-bind="filterParams"/>
        </modal> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import get from 'lodash/get';
import assign from 'lodash/assign'

import assignIn from "lodash/assignIn";
import Perfume from '@/models/catalog/perfume';
import Field from '@/models/services/field'
import Filter from '@/models/services/filter'
import Year from '@/models/catalog/Year';

import {
    CatalogListMixin,
    decadeDeclension,
    getApiQueryParams,
    getCatalogQuery
} from '@/mixins/catalog/catalogList.mixin';

import Breadcrumb from '@/components/layout/nav/Breadcrumb';
import PageBlock from '@/components/layout/AppPageBlock';
import SectionCard from '@/components/layout/AppSectionCard';
import CatalogList from '@/components/catalog/CatalogList';
import ArticleRowItem from '@/components/layout/blocks/ArticlesList/ArticleRowItem';
import LinkedPagesList from '@/components/layout/blocks/LinkedPagesList';
import BlockOffer from '@/components/catalog/BlockOffer';
import BlockPricePanel from '@/components/catalog/BlockPricePanel';
import AromaBox from '@/components/catalog/aromabox';

import PerfumesFilter from '@/components/catalog/filters/PerfumesFilter';
import ModalFilter from '@/components/catalog/filters/parts/ModalFilter';

export default {
    name: 'Years',
    components: {
        BlockOffer,
        LinkedPagesList,
        ArticleRowItem,
        CatalogList,
        SectionCard,
        PageBlock,
        Breadcrumb,
        PerfumesFilter,
        ModalFilter,
        BlockPricePanel,
        AromaBox
    },
    mixins: [CatalogListMixin],
    asyncData({ app, query, params, error }) {
        const perfume = new Perfume()
        const filter = new Filter()
        const field = new Field()
        const filterFields = new Field().custom('services', filter, perfume, field)

        // массив фильтров из query
        const catalogParams = getCatalogQuery(query, true)

        // берём параметры для запроса из query или дефолт
        const catalogItemsPerPage = 40;

        const perfumesParams = {
            ...getApiQueryParams(query, {}, 'q'),
            per_page: catalogItemsPerPage,
            page: 1
        };

        const filterParams = catalogParams.filters || {};

        // Формируем параметры
        const yearParams = assignIn({}, perfumesParams, filterParams, {
            year: params.code
        })

        const yearModel = new Year({
            code: params.code
        });

        const requests = [
            (new Year).find(params.code),
            perfume.params(yearParams).get(),
            yearModel.relatedArticles().get(),
            yearModel.relatedPages().get(),
            filterFields.get(),
            app.$api.get(`/years/${params.code}/aroma-boxes`)
        ];

        return Promise.all(requests).then(results => {
            const catalogPage = getApiQueryParams(query).page;
            const searchQuery = getApiQueryParams(query, {}, 'q').q;
            const sortType = getApiQueryParams(query).sort ? getApiQueryParams(query).sort : 'popularity';
            const sortOrder = getApiQueryParams(query).order || 'desc';

            const year = get(results, '[0]');
            const catalogItems = get(results[1], '[0].items', []);
            const perfumesCount = get(results, '[1][0].total', 0);
            const totalItems = get(results[1], '[0].total', 0);
            const catalogLastPage = get(results, '[1][0].lastPage', 1);
            const relatedArticles = results[2];
            const relatedPages = results[3];
            const filterFields = get(results, '[4][0]');
            if (filterFields.years) {
                delete filterFields.years;
            }

            const yearAromabox = get(results, '[5].data', [])

            const baseUrl = app.i18n.__baseUrl;
            const catalogHref = app.router.resolve({
                name: 'Years'
            }).href;

            const pageName = app.i18n.t('breadcrumbs.scents')
                + ' '
                + decadeDeclension(year.code, [ app.i18n.t('breadcrumbs.years_one'), app.i18n.t('breadcrumbs.years_decade')]);

            const breadcrumbs = [
                {
                    path: baseUrl,
                    name: app.i18n.t('breadcrumbs.perfumes'),
                },
                {
                    path: baseUrl + catalogHref,
                    name: app.i18n.t('breadcrumbs.years'),
                },
                {
                    path: baseUrl + catalogHref + year.code,
                    name: pageName
                }
            ];

            if (process.server) {
                app.store.dispatch('rest/headers/filterLastModified', {
                    url: [
                        `/years/${year.code}`,
                        `/years/${year.code}/perfumes`,
                    ]
                });
            }

            return {
                year,
                catalogItems,
                perfumesCount,
                sortType,
                catalogPage,
                sortOrder,
                catalogLastPage,
                filterFields,
                totalItems,
                relatedArticles,
                relatedPages,
                searchQuery,
                breadcrumbs,
                catalogItemsPerPage,
                filterParams: {...filterParams, year: params.code},
                filters: {...filterParams, year: params.code},
                staticFilters: ['year'],
                yearAromabox
            };
        }).catch((e) => {
            error({statusCode: e.response.status, message: e.response.data});
        });
    },
    data() {
        return {
            year: {},
            searchQuery: null,
            loaded: false,
            queryPending: false,
            catalogItems: [],
            relatedArticles: [],
            relatedPages: [],
            breadcrumbs: [],
            catalogPage: 1,
            catalogLastPage: 10,
            perfumesCount: 0,
            filterFields: {},
            filterParams: {},
            filters: {},
            filtersCount: 0,
            q: null,
            nameProp: 'q',
            sortType: 'popularity',
            sortOrder: 'desc',
            sortOptions: {
                popularity: {
                    name: this.$t('popular')
                },
                rating: {
                    name: this.$t('rating')
                },
                year: {
                    name: this.$t('date')
                },
                name: {
                    name: this.$t('alphabet')
                },
            },
            filterIsShowed: false,
            catalogItemsPerPage: null,
            singleButtonPagination: true,
            yearAromabox: []
        }
    },
    computed: {
        ...mapGetters(['isDeviceDesktop']),
        catalogQueryObject() {
            return new Perfume().where('year', this.year.code)
        },
        getYearTitle() {
            return this.$t('title') +
                    ' ' + this.decadeDeclension(get(this.year, 'code', 0), this.yearsDeclension);
        },
        yearsDeclension() {
            return [
                this.$t("years_one"),
                this.$t("years_decade")
            ]
        },
        yearPerfumesCaption() {
            let text = this.$options.filters.numberDeclension(
                this.perfumesCount, 
                this.$t('declensions.perfumes'), 
                false
            );

            if (this.q || this.searchQuery || Object.keys(this.filterParams).length > 1) {
                text += ' ' + this.$t('by_filter');
            };

            return text;
        }
    },
    watch: {
        itemsTotal(value) {
            this.perfumesCount = value
        },
    },
    mounted() {
        this.loaded = true;
        this.filtersCount = this.$refs.filter.filtersCount;
    },
    methods: {
        get,
        decadeDeclension
    },
    head() {
        return {
            title: get(this.year, 'meta.title'),
            meta: this.$options.filters.metaApiExtract(this.year),
            link: [
                {
                    hid: 'i18n-can',
                    rel: 'canonical',
                    href: get(this.year, 'meta.canonical')
                }
            ]
        }
    },
    globalBus: {
        'perfumes-filters-update'({ filters, url }) {
            filters.year = this.$route.params.code

            this.$nextTick(() => {
                this.filterParams = assign({}, filters)
            })
        },
    }
};
</script>

<style lang="less">
.year-page {
    @{desktop} & {
        margin-bottom: rem(85);
    }

    &__catalog{
        --grid-item-height: rem(298);

        @{desktop} & {
            margin-top: rem(40);
        }
        
        &.catalog-list{
            --grid-item-height: rem(298);
        }

        .rating{
            height: rem(13);
        }
    }

    &__title-name {
        @{desktop} & {
            --desktop-header-padding-top: rem(20);
            --desktop-header-padding-bottom: rem(8);

            margin-bottom: rem(32);
        }
    }

    .catalog-list__pagination-wrapper {
        @{desktop} & {
            margin-top: rem(30);
        }
    }
}
</style>